import React, { useEffect, useState, useRef } from "react";
import "./Shop.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Demo_Product from "../home/demo_product/Demo_Product";
import All_Product from "./all_Product/All_Product";
import Faq from "./faq/Faq";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import { useDispatch, useSelector } from "react-redux";
import {
  allProductMinMax,
  getAllCategories,
  getAllDataSubCategory,
  getAllOccasion,
  getAllProductSize,
  getAllSubCategory,
} from "../../features/master/masterSlice";

import { getAllProducts } from "../../features/products/productsSlice";
import { getHomeBanner } from "../../features/home/homeSlice";
import { useLocation, useSearchParams } from "react-router-dom";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";
import { Swiper, SwiperSlide } from "swiper/react";

import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Nav, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faSort } from "@fortawesome/free-solid-svg-icons";
import FilterComponent from "../common-components/filter_component/FilterComponent";
import {
  getColours,
  getPolish,
  getShape,
  getSizes,
} from "../../features/colour/colourSlice";
import Green_round_btn from "../common-components/common_btn/green_round_btn/Green_round_btn";
import Spinner from "react-bootstrap/Spinner";
import Sort_offcanvas from "../product/all_Product/sort_offcanvas/Sort_offcanvas";

function Shop() {
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "ALL PRODUCTS", link: "", isActive: true },
  ];

  const [searchParams, setSearchParams] = useSearchParams();
  // const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const categoryName = searchParams.get("category");
  const categoryId = searchParams.get("category_id");
  const subCategoryId = searchParams.get("sub_category_id");
  const subCategory = searchParams.get("sub_category");
  const [selectId, setSelectId] = useState();
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);

  const defaultFilters = {
    currentPage: 1,
    category: [],
    subCategoryName: [],
    subCategory: [],
    colors: [],
    sizes: [],
    polish: [],
    earringStyle: [],
    necklaceStyle: [],
    occasions: [],
    designShapes: [],
    priceRange: "",
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [appliedFilters, setAppliedFilters] = useState(defaultFilters);

  const location = useLocation();
  const isFetching = useRef(false);

  useEffect(() => {
    setCurrentPage(1);
    isFetching.current = false;
  }, [location.pathname, subCategory, categoryId]);
  const selectedCategoryRef = useRef(null);

  const dispatch = useDispatch();
  const categories = useSelector((state) => state.master.categories);
  const productminmax = useSelector((state) => state.master.product_min_max);
  const occasions = useSelector((state) => state.master.all_occasion);
  const productsize = useSelector((state) => state.master.product_size);
  const colours = useSelector((state) => state.colours.colour.data || []);
  const shapes = useSelector((state) => state.colours.shapes.data || []);
  const sizes = useSelector((state) => state.colours.size.data || []);
  const polishes = useSelector((state) => state.colours.polish.data || []);

  const productData = useSelector((state) => state.product.allProducts);
  const products = productData || [];

  useEffect(() => {
    if (productminmax?.max_price) {
      setFilters((prev) => ({
        ...prev,
        priceRange: productminmax.max_price,
      }));
    }
  }, [productminmax]);

  const updateFilter = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
    // setCurrentPage(1);
  };

  useEffect(() => {
    dispatch(getAllProductSize());
    dispatch(allProductMinMax());
    dispatch(getAllOccasion());
    dispatch(getAllCategories());
    dispatch(getColours());
    dispatch(getSizes());
    dispatch(getPolish());
    dispatch(getShape());
  }, [dispatch]);
  const allProductSubcategory = useSelector(
    (state) => state.master.all_subcategories,
  );
  const allsubcategory = useSelector((state) => state.master.subcategories);

  useEffect(() => {
    dispatch(getAllDataSubCategory());
  }, [dispatch]);
  // Set category from URL or first category
  useEffect(() => {
    if (!categoryId) return;
    const activeCategory = Number(categoryId);
    setAppliedFilters((prev) => ({
      ...prev,
      category: [],
    }));
    setSelectId(activeCategory);
    setFilters((prev) => ({
      ...prev,
      category: [activeCategory],
      // subCategory: [],
    }));

    setAppliedFilters((prev) => ({
      ...prev,

      category: [activeCategory],
      subCategory: [],
    }));
    setCurrentPage(1);
  }, [categories, categoryId]);

  useEffect(() => {
    if (!subCategory) return;
    setAppliedFilters((prev) => ({
      ...prev,
      subCategoryName: [],
    }));
    // if (!allsubcategory.length) return;
    const activeSubCategory = subCategory;
    // setSelectedSubCategoryId(activeSubCategory);

    setFilters((prev) => ({
      ...prev,
      subCategoryName: [activeSubCategory],
    }));
    setAppliedFilters((prev) => ({
      ...prev,
      subCategoryName: [activeSubCategory],
    }));
    setCurrentPage(1);
  }, [subCategory]);
  console.log(subCategory, "subCategory subCategory");

  useEffect(() => {
    if (!selectId) return;

    dispatch(getAllSubCategory({ category_id: selectId }));
  }, [dispatch, selectId]);

  // useEffect(() => {
  //   if (!subCategoryId) return;

  //   // if (!allsubcategory.length) return;

  //   const activeSubCategory = Number(subCategoryId);
  //   setSelectedSubCategoryId(activeSubCategory);

  //   const updated = {
  //     currentPage: 1,
  //     category: [selectId],
  //     subCategory: [activeSubCategory],
  //     subCategoryName: [],
  //   };

  //   setFilters((prev) => ({
  //     ...prev,
  //     ...updated,
  //   }));

  //   setAppliedFilters((prev) => ({
  //     ...prev,
  //     ...updated,
  //   }));
  //   setCurrentPage(1);
  // }, [selectId, subCategoryId]);

  const handleCategoryChange = (id) => {
    setSelectId(id);
    setSelectedSubCategoryId(null);
    setFilters((prev) => ({
      ...prev,
      currentPage: 1,
      category: [id],
      subCategory: [],
    }));

    setAppliedFilters((prev) => ({
      ...prev,
      currentPage: 1,
      category: [id],
      subCategory: [],
    }));
    setCurrentPage(1);
  };

  const [showFilter, setShowFilter] = useState(false);
  // SEARCH STATE
  const [searchTerm, setSearchTerm] = useState("");

  // SORT STATE
  const [sortType, setSortType] = useState("default");

  const [sortOrder, setSortOrder] = useState("");

  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const breakpoints = {
    0: { slidesPerView: 2, spaceBetween: 10 },
    486: { slidesPerView: 2.5, spaceBetween: 10 },
    576: { slidesPerView: 3, spaceBetween: 10 },
    768: { slidesPerView: 3, spaceBetween: 10 },
    992: { slidesPerView: 4, spaceBetween: 10 },
    1200: { slidesPerView: 5, spaceBetween: 10 },
    1400: { slidesPerView: 6, spaceBetween: 10 },
    1800: { slidesPerView: 7, spaceBetween: 10 },
  };

  const allProducts = useSelector((state) => state.product.allProducts) || [];
  const itemsPerPage = 8;

  const totalPages = useSelector((state) => state.product.total_pages) || 1;
  const current_page = useSelector((state) => state.product.currentPage) || 1;

  // useEffect(() => {
  //   setCurrentPage(current_page);
  // }, [current_page]);

  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  const handleSubCategoryClick = (subId) => {
    setSelectedSubCategoryId(subId);

    setFilters((prev) => ({
      ...prev,
      currentPage: 1,
      subCategory: [subId],
    }));

    setAppliedFilters((prev) => ({
      ...prev,
      currentPage: 1,
      subCategory: [subId],
    }));
    setCurrentPage(1);
  };

  const handleApplyFilters = async () => {
    setCurrentPage(1);
    setFilters((prev) => ({
      ...prev,
    }));
    setAppliedFilters(filters);
    const params = new URLSearchParams(window.location.search);
    params.set("category_id", "");
    params.set("sub_category_id", "");
    params.set("sub_category", "");
    setSearchParams(params);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`,
    );

    handleClose();
  };

  const handleClearFilters = async () => {
    setCurrentPage(1);
    setFilters(defaultFilters);
    setAppliedFilters(defaultFilters);
    const params = new URLSearchParams(window.location.search);
    params.set("category_id", "");
    params.set("sub_category_id", "");
    params.set("sub_category", "");
    setSearchParams(params);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`,
    );

    handleClose();
  };

  const [showSort, setShowSort] = useState(false);

  const handleCloseSort = () => {
    setShowSort(false);
    setShowFilter(false);
  };
  const handleShowSort = () => {
    setShowSort(true);
    setShowFilter(false);
  };
  const handleApplySort = async () => {
    setCurrentPage(1);
    setFilters((prev) => ({
      ...prev,
    }));

    // setAppliedFilters(filters);
    setAppliedFilters({ ...filters });

    handleCloseSort();
  };

  const handleClearSort = async () => {
    setCurrentPage(1);
    setSortOrder("");
    handleCloseSort();
  };

  useEffect(() => {
    const fetchProduct = async () => {
      setLoader(true);
      try {
        // if (appliedFilters.subCategoryName?.length > 0) {
        await dispatch(
          getAllProducts({
            page: currentPage,
            per_page: 8,
            category_id: appliedFilters.category.join(",") || categoryId,
            sub_category_id: appliedFilters.subCategory.join(","),
            sub_category:
              appliedFilters.subCategoryName.join(",") || subCategory,
            colour_id: appliedFilters.colors.join(","),
            polish_id: appliedFilters.polish.join(","),
            size_id: appliedFilters.sizes.join(","),
            earring_style: appliedFilters.earringStyle.join(","),
            necklace_style: appliedFilters.necklaceStyle.join(","),
            occasion: appliedFilters.occasions.join(","),
            design_shape: appliedFilters.designShapes.join(","),
            max_price: appliedFilters.priceRange,
            sortBy: sortOrder,
            name: searchTerm,
          }),
        );
        // }
      } catch (error) {
        console.error(error);
      } finally {
        setLoader(false);
      }
    };

    fetchProduct();
  }, [
    dispatch,
    appliedFilters,
    currentPage,
    subCategory,
    categoryId,
    // sortOrder,
  ]);

  const loading = useSelector((state) => state.product.loading);

  useEffect(() => {
    const handleScroll = () => {
      if (
        loading ||
        isFetching.current ||
        currentPage < 1 ||
        currentPage >= totalPages
      ) {
        return;
      }

      // const scrollTop =
      //   window.pageYOffset || document.documentElement.scrollTop;
      // const windowHeight = window.innerHeight;
      // const fullHeight = document.documentElement.scrollHeight;

      // if (scrollTop + windowHeight >= fullHeight - 300) {
      //   isFetching.current = true;
      //   setCurrentPage((prev) => prev + 1);
      // }
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
      );
      if (scrollTop + windowHeight >= fullHeight - 12000) {
        isFetching.current = true;
        setCurrentPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [loading, currentPage, totalPages]);

  useEffect(() => {
    if (!loading) {
      isFetching.current = false;
    }
  }, [loading]);

  console.log(
    appliedFilters.subCategoryName,
    "appliedFilters appliedFilters appliedFilters",
  );
  console.log(categoryId, "categoryId categoryId categoryId");
   console.log(subCategory, "subCategory subCategory subCategory");

  return (
    <>
      {loader && currentPage === 1 ? (
        <>
          <div className="position-fixed top-0 start-0 w-100 vh-100 d-flex justify-content-center align-items-center bg-white">
            <Spinner animation="border" variant="warning" />
          </div>
        </>
      ) : (
        <section className="Shop">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          {/* <Demo_Product
          filters={filters}
          products={categories}
          breakpoints={breakpoints}
          selectId={selectId}
          setSelectId={handleCategoryChange}
          selectedCategoryRef={selectedCategoryRef}
        />

        {allsubcategory?.length > 0 && (
          <>
            <div className="heading_holder">
              <h4 className="heading_text">Shop By Category</h4>
            </div>

            <Swiper
              className="mySwiper"
              breakpoints={{
                0: { slidesPerView: 2, spaceBetween: 10 },
                486: { slidesPerView: 2.5, spaceBetween: 10 },
                576: { slidesPerView: 3, spaceBetween: 10 },
                768: { slidesPerView: 3, spaceBetween: 10 },
                992: { slidesPerView: 4, spaceBetween: 10 },
                1200: { slidesPerView: 5, spaceBetween: 10 },
                1400: { slidesPerView: 6, spaceBetween: 10 },
                1800: { slidesPerView: 7, spaceBetween: 10 },
              }}
            >
              {allsubcategory?.map((slide, index) => (
                <SwiperSlide key={index} className="product-slide">
                  <Nav.Item>
                    <Nav.Link
                      className={
                        String(selectedSubCategoryId) === String(slide?.id)
                          ? "activecategory"
                          : ""
                      }
                      onClick={() => handleSubCategoryClick(slide?.id)}
                      // onClick={() => {
                      //   setSelectedSubCategoryId(slide.id);
                      // }}
                    >
                      <Category_Subcategory_Card
                        className="product-image second-swiper-product-image"
                        content={slide?.name}
                        image={
                          slide?.image
                            ? process.env.REACT_APP_IMG_URL + slide.image
                            : "/assets/images/common alex jewellery.png"
                        }
                        imgClassName="category-image"
                      />
                      <div className="triangle-right"></div>
                    </Nav.Link>
                  </Nav.Item>
                </SwiperSlide>
              ))}
            </Swiper>
          </>
        )} */}

          <All_Product
            handleCloseSort={handleCloseSort}
            handleShowSort={handleShowSort}
            handleClearFilters={handleClearFilters}
            handleClose={handleClose}
            handleShow={handleShow}
            allProducts={allProducts}
            selectId={selectId}
            categoryName={categoryName}
            subCategoryId={selectedSubCategoryId}
            filters={filters}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
          />

          {/* <div className="pagination pagination_holder mt-4 d-flex justify-content-center align-items-center gap-2">
          <button
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            &laquo;
          </button>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &lsaquo;
          </button>

          {[currentPage].map((page) => (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              className={page === currentPage ? "active" : ""}
            >
              {page}
            </button>
          ))}

          {totalPages > 3 && (
            <>
              <span>...</span>

              <button
                onClick={() => handlePageChange(totalPages)}
                className={currentPage === totalPages ? "active" : ""}
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            &rsaquo;
          </button>
          <button
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            &raquo;
          </button>
        </div> */}

          {/* MOBILE FILTER OFFCANVAS */}
          <Offcanvas
            show={showFilter}
            onHide={handleClose}
            placement="start"
            className="filter_offcanvas"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Filters</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
              <FilterComponent
                filters={filters}
                updateFilter={updateFilter}
                handleApplyFilters={handleApplyFilters}
                handleClearFilters={handleClearFilters}
                categories={categories}
                subCategories={allProductSubcategory}
                colours={colours}
                sizes={productsize}
                polishes={polishes}
                // earringStyles={earringStyles}
                // necklaceStyles={necklaceStyles}
                occasions={occasions}
                designShapes={shapes}
                productminmax={productminmax}
              />
            </Offcanvas.Body>
            {/* <div className="offcanvas-footer">
            <div className="d-flex gap-3 justify-content-center">
              <div className="filter-btn">
                <Green_round_btn btnText="Clear" />
              </div>

              <div className="filter-btn">
                <Green_round_btn btnText="Apply" />
              </div>
            </div>
          </div> */}
          </Offcanvas>
          <Sort_offcanvas
            selectId={selectId}
            show={showSort}
            handleApplySort={handleApplySort}
            handleClearSort={handleClearSort}
            handleClose={handleCloseSort}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
          />
        </section>
      )}
    </>
  );
}

export default Shop;
